export default {
    charities: {
        charitableGiving: 'Charitable Giving',
        charities: 'charities',
        profileTitleSuffix: 'Featured Charity',
        donateToday: 'Donate Today',
        visitWebsite: 'Visit charity website',
        backToFeaturedCharities: 'Back to featured charities',
        heroEyebrow: 'A gift that lives on',
        heroTitle: 'Leave a lasting gift to a cause you care about',
        heroBody:
            'Your Will can care for the people closest to you and support the causes that matter to you. NobleWills helps you record a charitable gift clearly as part of your estate plan.',
        heroImageAlt: 'Three volunteers assembling care kits together at a community centre',
        startWill: 'Start Your Will',
        meetPartners: 'Meet Our Featured Charities',
        howEyebrow: 'How it works',
        howTitle: 'Add a charitable gift in three simple steps',
        howBody:
            'To leave a charitable gift in your Will, choose a charity, choose a fixed amount or residuary share, and record the charity and gift details clearly in your Will.',
        step1Title: 'Choose a cause',
        step1Body: 'Name any charity that matters to you. It does not need to be featured by NobleWills.',
        step2Title: 'Choose your gift',
        step2Body: 'Leave a fixed amount or a share of what remains in your estate after other gifts and obligations.',
        step3Title: 'Record it in your Will',
        step3Body: 'Add the charity and gift details while completing your Will, then review them before finalising it.',
        giftTypesEyebrow: 'Your options',
        giftTypesTitle: 'Fixed and residuary gifts, in plain English',
        giftTypesBody: 'The right approach depends on what you want your gift to achieve and how you want the rest of your estate to be distributed.',
        fixedGiftTitle: 'Fixed gift',
        fixedGiftBody: 'A specific sum of money that you choose to leave to a charity.',
        residuaryGiftTitle: 'Residuary gift',
        residuaryGiftBody: 'A percentage or share of your estate left after debts, expenses, taxes, and other gifts have been dealt with.',
        giftExampleLabel: 'Illustrative example',
        fixedGiftExample: 'HK$50,000',
        residuaryGiftExample: '5% of what remains',
        giftExampleDisclaimer: 'This is not legal, tax, or financial advice.',
        giftFlexibility: 'Whichever option you choose, identify the charity clearly and keep your Will up to date if your wishes or the charity’s details change.',
        taxNote: 'Tax treatment varies by jurisdiction and personal circumstances. Consider speaking with a qualified tax or legal adviser if tax is relevant to your plans.',
        localPartnersEyebrow: 'Close to home',
        localPartnersTitle: 'Featured charities in {{location}}',
        localPartnersBody: 'Explore featured charities working in your local community.',
        worldwidePartnersEyebrow: 'Across our community',
        worldwidePartnersTitle: 'Featured charities worldwide',
        worldwidePartnersBody: 'Discover more featured organisations across the NobleWills community.',
        learnMore: 'Learn more about {{charity}}',
        partnerStripTitle: 'Charity partners around the world',
        partnerStripBody: 'Meet the organisations helping people, animals, communities, and the planet.',
        partnerStripCta: 'Explore charitable giving',
        recruitmentEyebrow: 'For charities',
        recruitmentTitle: 'Help more supporters leave a lasting legacy',
        recruitmentBody:
            'We work with charities to make legacy giving easier to understand and to help supporters record their wishes. Ask us about becoming a featured NobleWills charity partner.',
        recruitmentCta: 'Enquire about partnering',
        recruitmentFallback: 'Or contact our team',
        recruitmentMessage: 'Hello, I represent a charity and would like to learn more about becoming a NobleWills charity partner.',
        faqEyebrow: 'Common questions',
        faqTitle: 'Charitable giving FAQs',
        faq1Question: 'Can I leave a gift to a charity that is not listed here?',
        faq1Answer: 'Yes. The featured charities are suggestions only. You can name another charity that is important to you.',
        faq2Question: 'What is the difference between a fixed gift and a residuary gift?',
        faq2Answer:
            'A fixed gift is a specific amount of money. A residuary gift is a percentage or share of what remains in your estate after debts, expenses, taxes, and other gifts have been dealt with.',
        faq3Question: 'What charity details should I include?',
        faq3Answer:
            'Use the charity’s current legal name and, where available, its registration number and address. Clear details can help your executors identify the organisation you intended.',
        faq4Question: 'Can I change my charitable gift later?',
        faq4Answer: 'Yes. Review your Will when your wishes or circumstances change, and make any update using the signing requirements that apply to you.',
        faq5Question: 'Will a charitable gift reduce tax on my estate?',
        faq5Answer:
            'Tax treatment varies by jurisdiction and circumstances. If tax is relevant to your plans, consider advice from a qualified tax or legal adviser in the relevant jurisdiction.',
        finalEyebrow: 'Make your wishes count',
        finalTitle: 'Ready to include a cause in your Will?',
        finalBody: 'Start your Will and record the people and causes you want to remember.',
    },
};
